import CircularProgress from '@material-ui/core/CircularProgress'
import { Dayjs } from '@openhouse-technologies/utils'
import { isEmpty } from 'lodash'
import React from 'react'

import { commonAttributes, tableColumnDefaultOption } from 'app/config'
import { validateNotEmpty } from 'app/validators'

import { Link } from './styles'

export const MOMENT_SUBTYPES = {
  CAMERA: 'photo_video',
  NOTE: 'note',
  FOOD: 'food',
  TOILET: 'toilet',
  NAP: 'nap'
}

export const MOMENT_TYPE_FIELD_MAPPINGS = {
  [MOMENT_SUBTYPES.TOILET]: {
    label: 'Toilet',
    fields: {
      toilet_check: {
        label: 'Toilet Check',
        options: {
          potty_chair: {
            label: 'Potty Chair',
            iconSrc:
              'https://res.cloudinary.com/openhouse-study/image/upload/v1748867771/assets/moment%20observation%20icons/regular/Icons-16.svg'
          },
          accident: {
            label: 'Accident',
            iconSrc:
              'https://res.cloudinary.com/openhouse-study/image/upload/v1748867771/assets/moment%20observation%20icons/regular/Icons-17.svg'
          },
          diaper: {
            label: 'Diaper',
            iconSrc:
              'https://res.cloudinary.com/openhouse-study/image/upload/v1748867771/assets/moment%20observation%20icons/regular/Icons-15.svg'
          }
        }
      },
      observation: {
        label: 'Observation',
        options: {
          dry: {
            label: 'Dry',
            iconSrc:
              'https://res.cloudinary.com/openhouse-study/image/upload/v1748867771/assets/moment%20observation%20icons/regular/Icons-19.svg'
          },
          wet: {
            label: 'Wet',
            iconSrc:
              'https://res.cloudinary.com/openhouse-study/image/upload/v1748867771/assets/moment%20observation%20icons/regular/Icons-18.svg'
          },
          soiled: {
            label: 'Soiled',
            iconSrc:
              'https://res.cloudinary.com/openhouse-study/image/upload/v1748867771/assets/moment%20observation%20icons/regular/Icons-20.svg'
          }
        }
      }
    }
  },
  [MOMENT_SUBTYPES.NAP]: {
    label: 'Nap',
    fields: {
      duration: {
        label: 'Duration',
        iconSrc:
          'https://res.cloudinary.com/openhouse-study/image/upload/v1748872745/assets/moment%20observation%20icons/regular/duration.svg',
        formatValue: (value) => {
          return Dayjs(value, 'HH:mm:ss').format('HH:mm [hrs]')
        }
      },
      start_time: {
        label: 'Nap Start Time',
        iconSrc:
          'https://res.cloudinary.com/openhouse-study/image/upload/v1748872679/assets/moment%20observation%20icons/regular/clock.svg',
        formatValue: (value) => {
          return Dayjs(value, 'HH:mm:ss').format('hh:mm A')
        }
      },
      end_time: {
        label: 'Nap End Time',
        iconSrc:
          'https://res.cloudinary.com/openhouse-study/image/upload/v1748872679/assets/moment%20observation%20icons/regular/clock.svg',
        formatValue: (value) => {
          return Dayjs(value, 'HH:mm:ss').format('hh:mm A')
        }
      },
      position: {
        label: 'Position',
        options: {
          stomach: {
            label: 'Stomach',
            iconSrc:
              'https://res.cloudinary.com/openhouse-study/image/upload/v1748867771/assets/moment%20observation%20icons/regular/Icons.svg'
          },
          side: {
            label: 'Side',
            iconSrc:
              'https://res.cloudinary.com/openhouse-study/image/upload/v1748867771/assets/moment%20observation%20icons/regular/Icons-1.svg'
          },
          back: {
            label: 'Back',
            iconSrc:
              'https://res.cloudinary.com/openhouse-study/image/upload/v1748867771/assets/moment%20observation%20icons/regular/Icons-3.svg'
          }
        }
      },
      observation: {
        label: 'Observation',
        options: {
          restful: {
            label: 'Restful',
            iconSrc:
              'https://res.cloudinary.com/openhouse-study/image/upload/v1748867771/assets/moment%20observation%20icons/regular/Icons-6.svg'
          },
          restless: {
            label: 'Restless',
            iconSrc:
              'https://res.cloudinary.com/openhouse-study/image/upload/v1748867771/assets/moment%20observation%20icons/regular/Icons-4.svg'
          },
          sniffling: {
            label: 'Sniffling',
            iconSrc:
              'https://res.cloudinary.com/openhouse-study/image/upload/v1748867771/assets/moment%20observation%20icons/regular/Icons-5.svg'
          }
        }
      }
    }
  },
  [MOMENT_SUBTYPES.FOOD]: {
    label: 'Food',
    fields: {
      meal_type: {
        label: 'Meal Type',
        options: {
          am_snack: {
            label: 'AM Snack',
            iconSrc:
              'https://res.cloudinary.com/openhouse-study/image/upload/v1748867771/assets/moment%20observation%20icons/regular/Icons-9.svg'
          },
          pm_snack: {
            label: 'PM Snack',
            iconSrc:
              'https://res.cloudinary.com/openhouse-study/image/upload/v1748867771/assets/moment%20observation%20icons/regular/Icons-10.svg'
          },
          lunch: {
            label: 'Lunch',
            iconSrc:
              'https://res.cloudinary.com/openhouse-study/image/upload/v1748867771/assets/moment%20observation%20icons/regular/Icons-8.svg'
          }
        }
      },
      quantity: {
        label: 'Quantity',
        options: {
          all: {
            label: 'All',
            iconSrc:
              'https://res.cloudinary.com/openhouse-study/image/upload/v1748867771/assets/moment%20observation%20icons/regular/Icons-11.svg'
          },
          some: {
            label: 'Some',
            iconSrc:
              'https://res.cloudinary.com/openhouse-study/image/upload/v1748867771/assets/moment%20observation%20icons/regular/Icons-13.svg'
          },
          most: {
            label: 'Most',
            iconSrc:
              'https://res.cloudinary.com/openhouse-study/image/upload/v1748867771/assets/moment%20observation%20icons/regular/Icons-12.svg'
          },
          none: {
            label: 'None',
            iconSrc:
              'https://res.cloudinary.com/openhouse-study/image/upload/v1748867771/assets/moment%20observation%20icons/regular/Icons-14.svg'
          }
        }
      }
    }
  },
  [MOMENT_SUBTYPES.CAMERA]: {
    label: 'Media'
  },
  [MOMENT_SUBTYPES.NOTE]: {
    label: 'Note'
  }
}

export const columns = [
  {
    name: 'uuid',
    formDataKey: 'uuid',
    label: 'Id',
    editable: false,
    options: {
      display: false,
      filterKey: 'uuid'
    }
  },
  {
    name: 'file.type',
    label: 'File Type',
    editable: false,
    validate: validateNotEmpty,
    options: {
      ...tableColumnDefaultOption.options,
      filterKey: 'file_type',
      customBodyRender: (fileType) => {
        return isEmpty(fileType) ? 'N/A' : fileType
      }
    }
  },
  {
    name: 'file.url',
    label: 'Media',
    editable: false,
    options: {
      ...tableColumnDefaultOption.options,
      disableFilter: true,
      customBodyRender: (fileUrl) => {
        return isEmpty(fileUrl) ? (
          'N/A'
        ) : (
          <Link href={fileUrl} target="_blank">
            {fileUrl?.slice(0, 20).concat('....')}
          </Link>
        )
      }
    }
  },
  {
    name: 'posted_by.full_name',
    label: 'Teacher name',
    editable: false,
    validate: validateNotEmpty,
    options: {
      ...tableColumnDefaultOption.options,
      filterKey: 'posted_by_name'
    }
  },
  {
    name: 'posted_by.phone_number',
    label: 'Teacher Phone Number',
    editable: false,
    validate: validateNotEmpty,
    options: {
      ...tableColumnDefaultOption.options,
      filterKey: 'posted_by_phone_number'
    }
  },
  {
    name: 'schedules',
    label: 'Category name',
    editable: false,
    validate: validateNotEmpty,
    options: {
      ...tableColumnDefaultOption.options,
      filterKey: 'course_name',
      setCellProps: () => ({
        style: {
          minWidth: '400px',
          maxWidth: '400px',
          whiteSpace: 'pre-wrap'
        }
      }),
      customBodyRender: (value) => {
        return (
          <span>
            {Array.isArray(value) &&
              value
                .map((item) => {
                  return `${item?.batch?.course?.name}`
                })
                .join(' , ')}
          </span>
        )
      }
    }
  }
]

export const tableOptions = (isLoading) => ({
  enableNestedDataAccess: '.',
  filter: false,
  search: false,
  sort: false,
  print: false,
  download: false,
  delete: false,
  viewColumns: false,
  customToolbar: null,
  responsive: 'vertical',
  selectableRowsHideCheckboxes: true,
  customFooter: () => (isLoading ? <CircularProgress /> : <tfoot />),
  rowsPerPage: Infinity,
  textLabels: {
    body: {
      noMatch: !isLoading && (
        <span style={{ color: 'rgba(0, 0, 8, 0.5)', fontSize: '18px' }}>
          No data!
        </span>
      )
    }
  }
})
